import { DataItem, getDataClass } from 'scrivito'

import { DataClassName } from '@/Data/const'
import { TimerecordTeam } from '@/Data/TimerecordTeam/TimerecordTeamDataClass'
import { ensureString } from '@/utils/ensureString'
import { getDataItem } from '@/utils/getDataItem'

export interface TeamLeaderOption {
  label: string
  value: string
}

export const useTeamLeaders = (): TeamLeaderOption[] => {
  const leaderIds = Array.from(
    new Set(
      TimerecordTeam.all()
        .take()
        .map((item) => ensureString(item.get('leader')))
        .filter(Boolean),
    ),
  )

  const leaderItems = leaderIds
    .map((id) => {
      return getDataItem(getDataClass(DataClassName.TIMERECORD_USER)!, id)
        .dataItem
    })
    .filter((item): item is DataItem => item != null)

  const leaders = leaderItems.map((leader) => ({
    label: ensureString(leader.get('name')),
    value: leader.id(),
  }))

  return [{ label: 'All', value: 'all' }, ...leaders]
}
